/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getProductList = (params) =>
  makeApiCall(`/products/sampling/maintenance/list`, 'GET', params);

export const getProduct = (params) =>
  makeApiCall(`/products/sampling/maintenance/details`, 'GET', params);

export const postAddProduct = (params) =>
  makeApiCall(`/products/sampling/maintenance/create`, 'POST', params);

export const postUpdateProduct = (params) =>
  makeApiCall(`/products/sampling/maintenance/update`, 'POST', params);

export const getActiveSegment = (params) =>
  makeApiCall(`/products/sampling/maintenance/active-segments`, 'GET', params);

export const getActiveProducts = (params) =>
  makeApiCall(`/products/sampling/maintenance/search-product`, 'POST', params);

export const getProductSamplingMaintenanceInventoryReport = (params) =>
  makeApiCall(`/products/sampling/inventory/maintenance/report`, 'POST', params);

// INVENTORY
export const postInventoryProductsList = (params) =>
  makeApiCall(`/products/sampling/inventory/maintenance/list`, 'POST', params);

export const postInventoryAddProducts = (params) =>
  makeApiCall(`/products/sampling/inventory/maintenance/create`, 'POST', params);

export const postInventoryDeleteProducts = (params) =>
  makeApiCall(`/products/sampling/inventory/maintenance/delete`, 'POST', params);

export const postViewProduct = (params) =>
  makeApiCall(`/products/sampling/inventory/maintenance/show`, 'POST', params);

export const postInventoryUpdateProduct = (params) =>
  makeApiCall(`/products/sampling/inventory/maintenance/update`, 'POST', params);

export const getActiveMDProducts = (params) => makeApiCall(`/md-products/list`, 'GET', params);
